import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";

import * as api from "../../constant/NewAPI";
import Utils from "../../constant/Utils";
import Swal from "sweetalert2";

const BatchSwap = () => {


    const [instituteList, setInstituteList] = useState([]);
    const [sportList, setSportList] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [coachList, setCoachList] = useState([]);
    const [checkedStates, setCheckedStates] = useState([]);
    const [inputValues, setInputValues] = useState([]);
    const [sportDetailsList, setSportDetailsList] = useState([]);
    const [programList, setProgramList] = useState([]);
    const [errors, setErrors] = useState([]);
    const [instituteId, setInstituteId] = useState("");
    const [sportId, setSportId] = useState("");
    const [coachId, setCoachId] = useState("");
    const [sportDtlId, setSportDtlId] = useState("");
    const [swapProgramId, setSwapProgramId] = useState("");
    const [searchAddQuery, setSearchAddQuery] = useState("");
    const [showTable, setShowTable] = useState(false);

    const addcheckboxRefs = useRef([]);

    const roleId = localStorage.getItem("RoleId");

    useEffect(() => {
        listInstitutions();
        listProgram()
    }, [])

    function listInstitutions() {
        const getInsts = api.InstituteDd + '/' + roleId; //"?userId=" + userId + "&roleId=" + roleId;
        fetch(getInsts, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((insResponse) => insResponse.json())
            .then((insResult) => {
                if (insResult.code == 401) {
                    Utils.logoutUser();
                }
                setInstituteList(insResult.data)
            })
            .catch((error) => {
                console.log("Failed to fetch list of institutions", error)
            })
    }

    function listSport(insId: string) {
        const getSports = api.getSBSportList + "/" + insId;
        fetch(getSports, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sportResponse) => sportResponse.json())
            .then((sportResult) => {
                if (sportResult.error == false) {
                    setSportList(sportResult.data)
                } else {
                    Swal.fire(sportResult.message)
                    if (sportResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch list of sports", error)
            })
    }

    function listBatches(sprtId) {
        const getBtchLis = api.getSBBatchList + "/" + sprtId + "/" + instituteId;
        fetch(getBtchLis, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((btchResponse) => btchResponse.json())
            .then((btchResult) => {
                if (btchResult.code == 401) {
                    Utils.logoutUser();
                }
                setBatchList(btchResult.data)
                listProgram()
                setShowTable(true)
            })
            .catch((error) => {
                console.log("Failed to fetch list of batches", error)
            })
    }

    function listProgram() {
        const getProgList = api.ProgramList;
        fetch(getProgList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((progResponse) => progResponse.json())
            .then((progResult) => {
                if (progResult.code == 401) {
                    Utils.logoutUser();
                }
                setProgramList(progResult.data)
            })
            .catch((error) => {
                console.log("Failed to fetch list of programs", error)
            })
    }

    function cochList() {
        const getCoacList = api.CoachList + "/" + instituteId;
        fetch(getCoacList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((cochResponse) => cochResponse.json())
            .then((cochResult) => {
                if (cochResult.code == 401) {
                    Utils.logoutUser();
                }
                setCoachList(cochResult.data)
            })
            .catch((error) => {
                console.log("Failed to fetch list of coaches", error)
            })
    }

    function sportDetails(cochId) {
        const getSportDtls = api.SportDetailsInst + "/" + cochId + "/" + instituteId;
        // "?insId=" + instituteId + "&coach=" + cochId;
        fetch(getSportDtls, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sprtResponse) => sprtResponse.json())
            .then((sprtResult) => {
                if (sprtResult.code == 401) {
                    Utils.logoutUser();
                }
                setSportDetailsList(sprtResult.data)
            })
            .catch((error) => {
                console.log("Failed to fetch the sports list on coach", error);
            })
    }

    const filteredBatches = batchList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchAddQuery.toLowerCase()));
    });

    const handleCheckboxChange = (index) => {
        setCheckedStates((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));

        // Reset input and error if unchecked
        if (checkedStates[index]) {
            setInputValues(prev => {
                const newValues = { ...prev };
                delete newValues[index];
                return newValues;
            });
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[index];
                return newErrors;
            });
        }
    };

    const handleInputChange = (index, value) => {
        setInputValues(prev => ({
            ...prev,
            [index]: value,
        }));

        // Clear error when user types
        if (errors[index]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[index];
                return newErrors;
            });
        }
    };

    function swapBatch() {
        let hasError = false;
        const newErrors = {};
        const selectedBatchIds: { batchId: any; newName: any; }[] = [];


        Object.keys(checkedStates).forEach(index => {

            const isChecked = checkedStates[index];
            const inputValue = inputValues[index];

            if (isChecked) {
                if (!inputValue) {
                    hasError = true;
                    newErrors[index] = "Required field";
                } else {
                    selectedBatchIds.push({
                        batchId: batchList[index].batchId,
                        newName: inputValue,
                    });
                }
            }
        });

        if (hasError) {
            setErrors(newErrors);
            Swal.fire("Please enter the new batch name.");
        } else {

            let batchCreateCounter = 1;

            const formData = new FormData();
            formData.append('batchInstitutionId', instituteId);
            formData.append('batchCoachSwap', coachId);
            formData.append('sportNameSwap', sportDtlId);
            formData.append('programNameSwap', swapProgramId);
            formData.append('batches', JSON.stringify(selectedBatchIds));
            formData.append('role', roleId);
            formData.append('batchCreate', batchCreateCounter);

            batchCreateCounter++;

            const swpBtch = api.swapFullBatch;
            fetch(swpBtch, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData,
            })
                .then((uptdResponse) => uptdResponse.json())
                .then((updtResult) => {
                    if (updtResult.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: updtResult.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (updtResult.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: updtResult.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
        }
    }

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="coache-head-blk">
                                                    <div className="row align-items-center">
                                                        <div className="row col-md-12 court-sortby sortbyset">
                                                            <div className="col-md-6">
                                                                <div className="mt-10 mb-10">
                                                                    <h4 className="text-center">Swap Batch</h4>
                                                                </div>
                                                                <div className="mb-10 border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                                <form>
                                                                    <div className="col-md-8 mb-10">
                                                                        <label className="sortbytitle"><h6>Institute</h6></label>
                                                                        <Select
                                                                            value={instituteList.find(ins => ins.institutionId === instituteId) ? {
                                                                                value: instituteId,
                                                                                label: instituteList.find(ins => ins.institutionId === instituteId).institutionName
                                                                            } : null}
                                                                            onChange={(e) => {
                                                                                setInstituteId(e.value);
                                                                                listSport(e.value)
                                                                            }}
                                                                            placeholder="Select Institute"
                                                                            options={instituteList.map(ins => ({
                                                                                value: ins.institutionId,
                                                                                label: ins.institutionName
                                                                            }))}>
                                                                        </Select>
                                                                    </div>
                                                                    <div className="col-md-8 mb-10">
                                                                        <label className="sortbytitle"><h6>Sport</h6></label>
                                                                        <Select
                                                                            value={sportList.find(sprt => sprt.sportID === sportId) ? {
                                                                                value: sportId,
                                                                                label: sportList.find(sprt => sprt.sportID === sportId).SportName
                                                                            } : null}
                                                                            onChange={(e) => {
                                                                                setSportId(e.value);
                                                                                listBatches(e.value);
                                                                                cochList()
                                                                            }}
                                                                            placeholder="Select Sport"
                                                                            options={sportList.map(sprt => ({
                                                                                value: sprt.sportID,
                                                                                label: sprt.SportName
                                                                            }))}>
                                                                        </Select>
                                                                    </div>
                                                                </form>
                                                                {showTable && (
                                                                    <>
                                                                        <div className="mt-10 mb-10">
                                                                            <h4 className="text-center">New Batch Details</h4>
                                                                        </div>
                                                                    </>
                                                                )}
                                                                <div className="border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                                {showTable && (
                                                                    <>
                                                                        <div className="col-md-8 mb-10">
                                                                            <label className="sortbytitle"><h6>Coach</h6></label>
                                                                            <Select
                                                                                value={coachList.find(coch => coch.internalUserId === coachId) ? {
                                                                                    value: coachId,
                                                                                    label: coachList.find(coch => coch.internalUserId === coachId).coachName
                                                                                } : null}
                                                                                onChange={(e) => {
                                                                                    setCoachId(e.value)
                                                                                    sportDetails(e.value)
                                                                                }}
                                                                                placeholder="Please Wait.."
                                                                                options={coachList.map(coch => ({
                                                                                    value: coch.internalUserId,
                                                                                    label: coch.coachName
                                                                                }))}>
                                                                            </Select>
                                                                        </div>
                                                                        <div className="col-md-8 mb-10">
                                                                            <label className="sortbytitle"><h6>Sport</h6></label>
                                                                            <Select
                                                                                value={sportDetailsList.find(sprt => sprt.sportId === sportDtlId) ? {
                                                                                    value: sportId,
                                                                                    label: sportDetailsList.find(sprt => sprt.sportId === sportDtlId).sportName
                                                                                } : null}
                                                                                onChange={(e) => {
                                                                                    setSportDtlId(e.value);
                                                                                }}
                                                                                placeholder="Select Sport"
                                                                                options={sportDetailsList.map(sprt => ({
                                                                                    value: sprt.sportId,
                                                                                    label: sprt.sportName
                                                                                }))}>
                                                                            </Select>
                                                                        </div>
                                                                        <div className="col-md-8 mb-10">
                                                                            <label className="sortbytitle"><h6>Program</h6></label>
                                                                            <Select
                                                                                value={programList.find(prg => prg.programId === swapProgramId) ? {
                                                                                    value: swapProgramId,
                                                                                    label: programList.find(prg => prg.programId === swapProgramId).programName
                                                                                } : null}
                                                                                onChange={(e) => {
                                                                                    setSwapProgramId(e.value)
                                                                                }}
                                                                                placeholder="Select Program"
                                                                                options={programList.map(prg => ({
                                                                                    value: prg.programId,
                                                                                    label: prg.programName
                                                                                }))}>
                                                                            </Select>
                                                                        </div>
                                                                        <div className="border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                                        <div className="save-changes text-sm-end">
                                                                            <Link to="#" className="btn btn-secondary text-end close" onClick={swapBatch}>Swap Batch</Link>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="mt-10 mb-10">
                                                                    <h4 className="text-center">Batch List</h4>
                                                                </div>
                                                                <div className="border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                                {showTable && (
                                                                    <>
                                                                        <div className="table-responsive" style={{ maxHeight: "31.2rem" }}>
                                                                            <table className="table table-datatble">
                                                                                <tbody>
                                                                                    {Array.isArray(batchList) && batchList.map((btch, index) => (
                                                                                        <tr key={index}>
                                                                                            <td>
                                                                                                <div className="court-information profile-availability">
                                                                                                    <div className="token-slot mt-2" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                                                                                        <div className="form-check visits court-information">
                                                                                                            <label className="visit-btns">
                                                                                                                <input
                                                                                                                    type="checkbox"
                                                                                                                    className="form-check-input"
                                                                                                                    defaultValue={btch.batchId}
                                                                                                                    ref={el => addcheckboxRefs.current[index] = el}
                                                                                                                    onChange={() => handleCheckboxChange(index)}
                                                                                                                    checked={!!checkedStates[index]}
                                                                                                                />
                                                                                                                <span
                                                                                                                    className="visit-rsn"
                                                                                                                    data-bs-toggle="tooltip"
                                                                                                                    title={btch.batchName}
                                                                                                                >
                                                                                                                    {btch.batchName}
                                                                                                                </span>
                                                                                                            </label>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td>
                                                                                                {checkedStates[index] && (
                                                                                                    <div>
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            className={`form-control ${errors[index] ? 'is-invalid' : ''}`}
                                                                                                            placeholder="Enter New Batch Name"
                                                                                                            value={inputValues[index] || ''}
                                                                                                            onChange={(e) => handleInputChange(index, e.target.value)}
                                                                                                        />
                                                                                                        {errors[index] && (
                                                                                                            <div className="invalid-feedback">
                                                                                                                {errors[index]}
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </div>
                                                                                                )}
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        <div className="border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BatchSwap;